const resolveUserRole = (authUser = {}) => {
    const getStoredRole = () => {
        if (typeof window === "undefined") return "";
        return localStorage.getItem("user_role") || "";
    };

    const candidates = [
        authUser?.user_role,
        authUser?.user_type,
        authUser?.role,
        authUser?.workspace_role,
        authUser?.company_role,
        authUser?.role_name,
        authUser?.access_role,
        authUser?.forward?.user_role,
        authUser?.forward?.role,
        getStoredRole(),
    ];

    for (const value of candidates) {
        if (typeof value === "string" && value.trim()) {
            return value.trim().toLowerCase();
        }
    }

    if (authUser?.allow && typeof authUser.allow === "object") {
        const nested = [authUser.allow.user_role, authUser.allow.role];
        for (const value of nested) {
            if (typeof value === "string" && value.trim()) {
                return value.trim().toLowerCase();
            }
        }
    }

    return "";
};

export default resolveUserRole;
